import { render, staticRenderFns } from "./locationAreasUpdate.vue?vue&type=template&id=2178b5b4&scoped=true"
import script from "./locationAreasUpdate.vue?vue&type=script&lang=js"
export * from "./locationAreasUpdate.vue?vue&type=script&lang=js"
import style0 from "./locationAreasUpdate.vue?vue&type=style&index=0&id=2178b5b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2178b5b4",
  null
  
)

export default component.exports